"use client"

import { useState } from "react"
import { api } from "@/lib/api"

interface UseWilsonModeReturn {
    demoMode: boolean
    maxMode: boolean
    setMaxMode: (value: boolean) => void
}

export function useWilsonMode(): UseWilsonModeReturn {
    const { data: org } = api.org.getMyOrg.useQuery()
    const [maxMode, setMaxMode] = useState(false)

    const demoMode = org?.demoMode ?? false

    return {
        demoMode,
        maxMode,
        setMaxMode,
    }
}
